'use client';
import cn from 'classnames';
import { usePathname, useRouter } from 'next/navigation';

import { KEY_CODES } from '@/constant/common';
import { useKeyDown } from '@/hooks/useKeyDown';
import { resolvePath, toAbsolutePath } from '@/utils/navigation';

import { Condition } from '../../Condition';
import s from './styles.module.scss';
import { LinkWithArrow } from './utils';
type NavBlock = {
  title: string;
  link: string;
};

export type FooterNavProps = {
  next?: NavBlock;
  prev?: NavBlock;
};

export function FooterNav({ next, prev }: FooterNavProps) {
  const { push } = useRouter();
  const pathname = usePathname();

  const normalize = (link: string) => resolvePath(toAbsolutePath(pathname), link);
  const prevLink = prev?.link;
  const nextLink = next?.link;

  const normalizedNext = normalize(nextLink || '');
  const normalizedPrev = normalize(prevLink || '');

  useKeyDown(KEY_CODES.arrowLeft, () => prevLink && push(normalizedPrev));
  useKeyDown(KEY_CODES.arrowRight, () => nextLink && push(normalizedNext));

  return (
    <div className={s.root}>
      <div className={cn(s.block, s.block_left)}>
        <Condition when={Boolean(prevLink)}>
          <LinkWithArrow href={normalizedPrev} direction='prev'>
            {prev?.title}
          </LinkWithArrow>
        </Condition>
      </div>
      <div className={cn(s.block, s.block_right)}>
        <Condition when={Boolean(nextLink)}>
          <LinkWithArrow href={normalizedNext} direction='next'>
            {next?.title}
          </LinkWithArrow>
        </Condition>
      </div>
    </div>
  );
}
